import React, { useState } from 'react';
import { Button } from '../ui';
import styles from './Accounts.module.css';

// Shown after an account is created/invited without a password. `invite` is
// the backend's {sent, error, setup_link}: when the email went out this is a
// plain confirmation; when it didn't (e.g. the school has no email set up)
// the administrator gets the link to pass on themselves.
function SetupLinkNotice({ invite, email }) {
  const [copied, setCopied] = useState(false);
  if (!invite) return null;

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(invite.setup_link);
      setCopied(true);
    } catch {
      setCopied(false);
    }
  };

  if (invite.sent) {
    return <div className="alert alert-success">A link to set their password was emailed to {email}. It works for 7 days.</div>;
  }

  return (
    <div className="alert alert-warning">
      The set-password email could not be sent{invite.error ? ` (${invite.error})` : ''}. Share this link with them directly — it works once, for 7 days:
      <div className={styles.linkRow}>
        <input className={styles.linkInput} readOnly value={invite.setup_link} onFocus={(e) => e.target.select()} aria-label="Set-password link" />
        <Button variant="secondary" size="sm" onClick={copy}>{copied ? 'Copied' : 'Copy'}</Button>
      </div>
    </div>
  );
}

export default SetupLinkNotice;
